import TableList from "@components/templates/tablelist";
import { HttpAddressList, } from "@/service/headlogistics";
export default {
    mixins: [TableList],
    data() {
        return {
            // totals: 0,
            isMixin: true,
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
                align: "left",
            },
        };
    },
    methods: {
        ajaxRequest: HttpAddressList,
        interceptRequest(params) {
            params.search.EQ_warehouseType = 2
            return params
        },
    },
    computed: {
        SearchsData() {
            return [
                {
                    label: "code",
                    tag: 'vInput',
                    key: 'CN_code',
                    show: true,
                    style: 'margin-right: 630px;'
                },]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "code",
                key: 'code'
            }, {
                title: "address",
                key: 'address'
            },
            {
                title: this.$t('global.common.operation', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
